import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'xp-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent implements OnInit {

  @Input()
  public imagePath: string = '';

  constructor() {
  }

  public get maskingStyle(): { [p: string]: string } {
    /* eslint-disable @typescript-eslint/naming-convention */
    return {
      'mask-image': 'url(' + this.imagePath + ')',
      '-webkit-mask-image': 'url(' + this.imagePath + ')',
      'mask-repeat': 'no-repeat',
      '-webkit-mask-repeat': 'no-repeat',
      'mask-position': 'center',
      '-webkit-mask-position': 'center',
      'mask-size': '100% 100%',
      '-webkit-mask-size': '100% 100%',
    };
    /* eslint-enable @typescript-eslint/naming-convention */
  }

  public ngOnInit(): void {
  }

}
